document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn = document.getElementById('notificationToggle');
  const panel = document.getElementById('notificationPanel');
  const closeBtn = document.getElementById('notificationClose');

  toggleBtn?.addEventListener('click', function (e) {
    e.preventDefault();
    panel.classList.toggle('open');
  });

  closeBtn?.addEventListener('click', function () {
    panel.classList.remove('open');
  });

  // Optional: zavření klikem mimo panel
  document.addEventListener('click', function (e) {
    if (!panel.contains(e.target) && !toggleBtn.contains(e.target)) {
      panel.classList.remove('open');
    }
  });
});
